export default __webpack_public_path__ + "static/erdinger_radler_3-8f953fa3a1832d7ec4b5d1c60a79312a.png";